module.exports = __webpack_public_path__ + "5102bab03db6e13a165043eedab1e332.svg";